import React, { useState } from 'react';
import { useNavigation } from '@react-navigation/native';

import { useUserContext } from '../../../common/utils/context';

import {
	View,
} from 'react-native';

import {
	TypographyParagraph,
	Dialog,
	Picker,
	SettingsRow,
	SettingsSection,
	SettingsSwitchRow,
} from '../../components';
import { SecondaryButton } from '../../design/components';
import { useThemedStyles } from '../../hooks/useThemedStyles';

import { pickListSummarySortOptions } from '../../utils/sortMethods';

// Wide enough for the longest option ("Alphabetical: asc") at 390 pt.
const SORT_PICKER_WIDTH = 180;

// Grouped rows like the pick list's own settings (PlanogramDetailFilterDialog).
const PickListSummarySettings = ({
	showAllSelections,
	hideImages,
	showProductNames,
	showExpiryWarnings,
	sortMethod,

	toggleShowAllSelections,
	toggleHideImages,
	toggleShowProductNames,
	toggleShowExpiryWarnings,
	setSortMethod,
}) => {
	const navigation = useNavigation();
	const styles = useThemedStyles(createStyles);
	const [isDialogOpen, setIsDialogOpen] = useState(false);
	const { tenantSettings } = useUserContext();

	const goToSettings = () => {
		setIsDialogOpen(false);
		navigation.push('SettingsView');
	};

	return (
		<>
			<SecondaryButton
				onPress={() => setIsDialogOpen(true)}
				label="Settings"
				icon="sliders"
			/>
			<Dialog
				isOpen={isDialogOpen}
				onClose={() => setIsDialogOpen(false)}
			>
				<View style={styles.optionsContainer}>
					<SettingsSection title="View settings" style={styles.firstSection}>
						<SettingsRow label="Sort by">
							<Picker
								selectedValue={sortMethod}
								onValueChange={value => setSortMethod(value)}
								options={pickListSummarySortOptions}
								width={SORT_PICKER_WIDTH}
							/>
						</SettingsRow>
						<SettingsSwitchRow
							onValueChange={toggleShowAllSelections}
							value={showAllSelections}
							label="Show all selections"
						/>
						{tenantSettings?.useExpiryDates && (
							<SettingsSwitchRow
								onValueChange={toggleShowExpiryWarnings}
								value={showExpiryWarnings}
								label="Show expiry warnings"
							/>
						)}
					</SettingsSection>
					<SettingsSection title="List settings">
						<SettingsSwitchRow
							onValueChange={toggleHideImages}
							value={hideImages}
							label="Hide images"
						/>
					</SettingsSection>
					<SettingsSection title="Grid settings">
						<SettingsSwitchRow
							onValueChange={toggleShowProductNames}
							value={showProductNames}
							label="Show product names"
						/>
					</SettingsSection>
					<View style={styles.defaultsLinkRow}>
						<TypographyParagraph
							text="To change defaults, "
						/>
						<TypographyParagraph
							text="go to settings"
							href={true}
							onPress={goToSettings}
						/>
					</View>
				</View>
			</Dialog>
		</>
	);
};

const createStyles = ({ ui: { colors, space } }) => ({
	optionsContainer: {
		minWidth: 280,
	},
	firstSection: {
		marginTop: 0,
	},
	defaultsLinkRow: {
		flexDirection: 'row',
		flexWrap: 'wrap',
		marginTop: space.md,
		paddingTop: space.md,
		borderTopColor: colors.border,
		borderTopWidth: 1,
	},
});

export default PickListSummarySettings;
